<script setup lang="ts">
const props = defineProps<{
  type: 'terms-and-conditions' | 'data-security' | 'imprint'
}>()
const { locale } = useI18n()
const path = computed(() => `/legal/${props.type}-${unref(locale).toLowerCase()}`)
const [error, doc] = await attempt(() => queryCollection('legal').where('path', 'LIKE', path.value).first())
</script>

<template>
  <div
    id="legal-document"
    class="container--center"
  >
    <h1 v-if="error">
      Unable to load document, try again please
    </h1>
    <ContentRenderer v-else :value="doc!" />
  </div>
</template>

<style lang="sass">
#legal-document
  h1
    margin-bottom: 24px !important
    line-height: 1.2 !important
</style>
